import React from "react";
import ReactDOM from "react-dom/client";
import Navbar from "./components/Navbar";
import "./index.css";
import About from "./pages/About";
import HomePage from "./pages/HomePage";
import AnimatedCursor from "react-animated-cursor";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AnimatedCursor
        innerSize={10}
        outerSize={16}
        opacity="0.3"
        outerAlpha={0.2}
        innerScale={1}
        outerScale={1.7}
        outerStyle={{
          opacity: 0.5,
          background: "#ffb40063",
          padding: "10px",
          zIndex: "50",
        }}
        innerStyle={{
          background: "#ffb400",
          padding: 0,
        }}
      />
      <Navbar />
      <Routes>
        <Route path="/about" element={<About />} />
        <Route path="/project" element={<Projects/>} />
        <Route path="/Contact" element={<Contact/>} />
        <Route path="/" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
